import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { AppFilter, ConfirmModal } from 'src/modules/shared';
import { AddSubtopicModal } from '../../modals/add-subtopic-modal/add-subtopic-modal.component';
import { AddTopicModal } from '../../modals/add-topic-modal/add-topic-modal.component';
import { ViewDetailsModal } from '../../modals/view-details-modal/view-details-modal.component';
import { EditTopicModal } from '../../modals/edit-topic-modal/edit-topic-modal.component';
import { ChatService } from 'src/modules/features/admin/services';
import { environment } from 'src/environments/environment';
import { AssignSubtopicModal } from '../../modals/assign-subtopic-modal/assign-subtopic-modal.component';

interface IHeaders {
  field?: string;
  label?: string;
  type?: string;
  choices?: any[];
  op?: string;
  data?: any;
}

@Component({
  selector: 'app-chat-configuration',
  templateUrl: './chat-configuration.component.html',
  styleUrls: ['./chat-configuration.component.scss'],
})
export class ChatConfigurationComponent implements OnInit {
  collapse = true;

  conversations: any[];
  filter: AppFilter = new AppFilter();
  success;
  error;
  pending = false;
  baseUrl = environment.API_SERVER;
  organizationId: any;
  currentPage: number = 1;

  topics: any;
  newTopic;
  selectedTopic;
  selectedSubTopic;
  searchMessagesFilter = {
    groupOp: 'OR',
    rules: [],
  };
  searchFilter = {
    groupOp: 'OR',
    rules: [],
  };
  headers: IHeaders[] = [
    {
      field: 'service.serviceTypeId',
      label: 'Service Type Id',
      type: 'text',
      op: 'cn',
      data: '',
    },
  ];

  topicsOptions = [
    {
      optionId: 'licensingService',
      optionName: 'Licensing Service',
    },
    {
      optionId: 'accountsManagementService',
      optionName: 'Accounts Management Service',
    },
    {
      optionId: 'complianceService',
      optionName: 'Compliance Service',
    },
    {
      optionId: 'typeApprovalEquipment',
      optionName: 'Type Approval of Equipment',
    },
  ];

  subtopicsOptions = [
    {
      optionId: 'new-type',
      optionName: 'New Type Approval Management',
    },
    {
      optionId: 'archived',
      optionName: 'Archived Type Approval Management',
    },
    {
      optionId: 'new',
      optionName: 'New Individual License',
    },
    {
      optionId: 'renewal',
      optionName: 'Renewal Individual License',
    },
    {
      optionId: 'ftp',
      optionName: 'Compliance FTP Data Submission',
    },
    {
      optionId: 'activity',
      optionName: 'Compliance Activity Data Submission',
    },
    {
      optionId: 'payment',
      optionName: 'User Payment Service',
    },
    {
      optionId: 'task',
      optionName: 'User Task Service',
    },
  ];

  headerFilters: any[];
  assignedUsers;
  activatedSubtopicId;
  activatedTopic;
  assignedPending: boolean = false;
  constructor(
    private location: Location,
    private modalService: SuiModalService,
    private activatedRoute: ActivatedRoute,
    private chatService: ChatService,
    private router: Router
  ) {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.activatedSubtopicId = params['subtopicId'];
      if (this.activatedSubtopicId) {
        this.getSubTopicUsers(this.activatedSubtopicId);
      }
    });
  }

  toggleCollapse() {
    this.collapse = !this.collapse;
  }

  findTopicBySubtopicId(subtopicId) {
    for (const topic of this.topics) {
      for (const subtopic of topic.subtopicList) {
        if (subtopic.subtopicId === subtopicId) {
          return topic;
        }
      }
    }
    return null; // Return null if subtopicId is not found in any topic
  }
  findActiveSubtopicBySubtopicId(subtopicId) {
    for (const topic of this.topics) {
      for (const subtopic of topic.subtopicList) {
        if (subtopic.subtopicId === subtopicId) {
          return subtopic;
        }
      }
    }
    return null;
  }
  addNewTopic() {
    this.modalService
      .open(new AddTopicModal('Add Topic', {}))
      .onApprove((value: any) => {
        this.success = 'Topic added successfully';
        // this.router.navigate(['/admin/setting/chat-config']);
        this.getTopics();
      })
      .onDeny(() => {
        // do nothing
      });
  }

  formatDate(date: string) {
    return new Date(date).toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  }
  getSubTopicUsers(subTopicId: string) {
    this.assignedPending = true;
    this.chatService.getAssignedUsers({ subTopicId: subTopicId }).subscribe(
      (response: any) => {
        this.assignedPending = false;
        this.pending = false;
        this.assignedUsers = response;
        this.assignedUsers.forEach((user) => {
          if (user.appUser.image) {
            user.appUser.image = `${
              this.baseUrl
            }/public/image/?media=${user.appUser.image.replace(/\\/g, '/')}`;
          }
        });
      },
      (error) => {
        this.assignedPending = false;
        this.pending = false;
        this.error == error.error.errorMessage ?? error.error ?? error;
      }
    );
  }
  getCreatorName(createdBy: string) {
    return JSON.parse(createdBy)?.name;
  }

  getTopics() {
    this.pending = true;
    this.chatService.getTopics({ params: this.filter }).subscribe(
      (response: any) => {
        this.topics = response['rows'];
        if (this.activatedSubtopicId) {
          this.activatedTopic = this.findTopicBySubtopicId(
            this.activatedSubtopicId
          );
          this.selectSubTopic(
            this.findActiveSubtopicBySubtopicId(this.activatedSubtopicId),
            this.activatedTopic
          );
        }
        this.getSub();
        this.pending = false;
        console.log(this.topics, 'topic');
      },
      (error) => {
        this.pending = false;
        this.error == error.error.errorMessage ?? error.error ?? error;
      }
    );
  }
  getSub(): void {
    this.pending = true;
    this.chatService.getAllChatSubTopics({}).subscribe(
      (res: any) => {
        this.pending = false;
        this.headerFilters = this.topics.map((topic) => {
          return {
            field: `subtopic.subtopicId`, // Assuming the field format is 'topic.topicId'
            label: topic.topic, // Use the topic name as the label
            type: 'select',
            op: 'eq',
            choices: [], // This will be populated later based on subtopics
            data: '',
          };
        });
        this.headerFilters.forEach((headerFilter) => {
          const filteredSubtopics = res.filter(
            (subtopic) => subtopic.topic.topic === headerFilter.label
          );
          headerFilter.choices = filteredSubtopics.map((subtopic) => ({
            optionId: subtopic.subtopicId,
            optionName: subtopic.subtopic,
          }));
        });
        console.log(this.headerFilters, 'filters');
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error.error.error
          ? error.error.error
          : error.error
          ? error.error
          : error;
      }
    );
  }
  ngOnInit(): void {
    this.getTopics();
  }

  selectSubTopic(activeSubtopic, activeTopic) {
    // console.log(activeSubtopic,activeTopic);
    this.selectedSubTopic = activeSubtopic;
    // console.log(this.selectedSubTopic)
    this.selectedTopic = activeTopic;
    // console.log(activeSubtopic.subtopic, activeTopic.topic);
    // get Subtopic permissions;
  }

  goBack() {
    this.location.back();
  }
  deleteUsers(id) {
    this.modalService
      .open(
        new ConfirmModal(
          'Delete Selected Assigned Users',
          'Are you sure you want to delete these Assigned  Users?',
          ModalSize.Small,
          'Delete',
          'Cancel'
        )
      )
      .onApprove((value: any) => {
        this.pending = true;
        const selectedUsers = this.assignedUsers.filter(
          (user) => user.selected
        );
        const selectedUserIds = selectedUsers.map(
          (user) => user.appUser.appUserId
        );
        let body = {
          appUserIds: selectedUserIds,
          subtopicIds: [id],
        };
        this.chatService.deleteAssignedUsers({ body: body }).subscribe(
          (response) => {
            this.success = 'Assigned Users deleted successfully';
            this.getSubTopicUsers(this.activatedSubtopicId);
          },
          (error) => {
            this.pending = false;
            this.error = error.error.errorMessage
              ? error.error.errorMessage
              : error.error.error
              ? error.error.error
              : error.error
              ? error.error
              : error;
          }
        );
      })
      .onDeny(() => {});
  }

  updatePermissionUsers() {
    this.modalService
      .open(
        new ConfirmModal(
          'Manage Assigned Users',
          'Are you sure you want to update the permission of  these Assigned  Users?',
          ModalSize.Small,
          'Update',
          'Cancel'
        )
      )
      .onApprove((value: any) => {
        this.pending = true;
        const userPermissions = this.assignedUsers.map((user) => ({
          appUserId: user.appUser.appUserId,
          subtopicId: user.subtopic.subtopicId,
          read: user.read,
          write: user.write,
          watch: user.watch,
          delete: user.delete,
        }));
        let body = {
          permissions: userPermissions,
        };
        this.chatService.assignUserSubTopic({ body: body }).subscribe(
          (response) => {
            this.success = 'Assigned Users Management updated successfully';
            this.getSubTopicUsers(this.activatedSubtopicId);
          },
          (error) => {
            this.pending = false;
            this.error = error.error.errorMessage
              ? error.error.errorMessage
              : error.error.message
              ? error.error.message
              : error.error.error
              ? error.error.error
              : error.error
              ? error.error
              : error;
          }
        );
      })
      .onDeny(() => {});
  }
  addSubtopic(item) {
    this.modalService
      .open(new AddSubtopicModal('Add Sub-topic', item))
      .onApprove((value: any) => {
        // update ui
        // get topic data
        this.success = 'Subtopic added successfully';
        this.getTopics();
      })
      .onDeny(() => {
        // do nothing
      });
  }
  checkIfSelected() {
    return this.assignedUsers.some((user) => user.selected === true);
  }

  editTopic(item) {
    this.modalService
      .open(new EditTopicModal('Edit Topic', item))
      .onApprove((value: any) => {
        this.success = 'Topic updated successfully';
        this.getTopics();
        // update ui
        // get topic data
      })
      .onDeny(() => {
        // do nothing
      });
  }

  deleteTopic(item) {
    this.modalService
      .open(
        new ConfirmModal(
          'Delete Topic',
          'Are you sure you want to delete this topic?',
          ModalSize.Small,
          'Delete',
          'Cancel'
        )
      )
      .onApprove((value: any) => {
        this.pending = true;
        this.chatService.deleteTopic({ topicId: item.topicId }).subscribe(
          (response) => {
            this.success = 'Topic deleted successfully';
            this.getTopics();
          },
          (error) => {
            this.error = error.error.errorMessage ?? error.error ?? error;
          }
        );
        // update ui
        // get topic data
      })
      .onDeny(() => {});
  }
  searchRecords(search) {
    let searchFilter = {
      groupOp: 'OR',
      rules: [
        {
          field: 'topic',
          op: 'cn',
          data: '',
        },
      ],
    };
    searchFilter.rules[0].data = search;
    this.filter._search = true;
    this.filter.filters = JSON.stringify(searchFilter);
    this.getTopics();
  }
  advancedSearch(search) {
    console.log(search, 'search');
    if (search) {
      // this.filter = search;
      this.filter._search = true;
      this.filter.filters = JSON.stringify(search);
    } else {
      this.filter.filters = {};
      this.filter._search = false;
    }
    this.currentPage = 1;
    this.filter.page = this.currentPage;
    this.filter.sidx = 'dateCreated';
    this.getTopics();
    console.log(this.filter);
  }
  cancelAd() {
    this.filter = new AppFilter({
      page: 1,
      rows: 100,
      _search: false,
    });
    this.getTopics();
  }
  viewTopic(item) {
    this.modalService
      .open(new ViewDetailsModal('View Topic Details', item))
      .onApprove((value: any) => {})
      .onDeny(() => {
        // do nothing
      });
  }

  refresh(message) {
    this.success = message;
    this.getTopics();
    this.getSubTopicUsers(this.activatedSubtopicId);
  }
  assignSubtopicToUser(item) {
    this.modalService
      .open(
        new AssignSubtopicModal(
          'Add User to sub-topic',
          item,
          this.assignedUsers.map((user) => user.appUser.appUserId)
        )
      )
      .onApprove((value: any) => {
        this.refresh('');
      })
      .onDeny(() => {
        // do nothing
      });
  }
}
